import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon58: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M2.929 2.926c3.899-3.901 10.243-3.901 14.142 0A9.94 9.94 0 0 1 20 10a9.943 9.943 0 0 1-2.929 7.075A9.966 9.966 0 0 1 10 20a9.966 9.966 0 0 1-7.071-2.925A9.943 9.943 0 0 1 0 10a9.94 9.94 0 0 1 2.929-7.074ZM10 1a8.968 8.968 0 0 0-6.364 2.633A8.946 8.946 0 0 0 1 10c0 2.405.936 4.665 2.636 6.366 3.509 3.512 9.219 3.512 12.728 0A8.945 8.945 0 0 0 19 10a8.946 8.946 0 0 0-2.636-6.367A8.968 8.968 0 0 0 10 1Zm3.5 12.996a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1h7Zm-6.5-8a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2Zm6 0a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2Z"
      />
    </Svg>
  )
}
